import Lib from '../../commons/lib';

export default class Service {
  static hirlevelUrl = window.location.origin + '/api/hirlevel/';

  static telepulesUrl = window.location.origin + '/api/telepules/';

  static gdprUrl = window.location.origin + '/api/gdpr/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  static helszinUrl = window.location.origin + '/api/helyszin/';

  static editorUrl = window.location.origin + '/api/editor/';

  // static editorUrl = window.location.origin + '/api/editor/';

  // static editorUrl = 'http://192.168.2.142:8288';

  // FELIRATKOZAS START

  static getInitfilter(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'feliratkozo/admin/initfilter',
      args: { requestType: 'feliratkozo-admin-initfilter' },
    }], fnDone);
  }

  static initFeliratkozo(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'feliratkozo/admin/init',
      args: { requestType: 'feliratkozo-admin-init' },
    }], fnDone);
  }

  static listFeliratkozok(filterObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'feliratkozo/admin/list',
      args: { requestType: 'feliratkozo-admin-list' },
      data: filterObj
    }], fnDone);
  }

  static getFeliratkozo(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'feliratkozo/admin',
      args: { requestType: 'feliratkozo-admin' },
      params: { id: id }
    }], fnDone);
  }

  static addFeliratkozo(feliratkozoObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'feliratkozo/admin',
      args: { requestType: 'feliratkozo-post' },
      data: feliratkozoObject
    }], fnDone);
  }

  static editFeliratkozo(feliratkozoObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'feliratkozo/admin',
      args: { requestType: 'feliratkozo-put' },
      data: feliratkozoObject
    }], fnDone);
  }

  static deleteFeliratkozo(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.hirlevelUrl + 'feliratkozo/admin',
      args: { requestType: 'feliratkozo-delete' },
      params: { id: id }
    }], fnDone);
  }

  static importFeliratkozok(id, importObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'feliratkozo/admin/import',
      args: { requestType: 'feliratkozo-admin-post' },
      contentType: 'text/csv',
      data: importObject,
      params: { id: id }
    }], fnDone);
  }

  // FELIRATKOZAS END

  // KATEGORIA START

  static listKategoriak(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'kategoria/list',
      args: { requestType: 'kategoria-list' }
    }], fnDone);
  }

  static initKategoriak(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'kategoria/init',
      args: { requestType: 'kategoria-init' }
    }], fnDone);
  }

  static getKategoria(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'kategoria',
      args: { requestType: 'kategoria' },
      params: { id: id }
    }], fnDone);
  }

  static addKategoria(kategoriaObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'kategoria',
      args: { requestType: 'kategoria-post' },
      data: kategoriaObject
    }], fnDone);
  }

  static editKategoria(kategoriaObject, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'kategoria',
      args: { requestType: 'kategoria-put' },
      data: kategoriaObject
    }], fnDone);
  }

  static deleteKategoria(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.hirlevelUrl + 'kategoria',
      args: { requestType: 'kategoria' },
      params: { id: id }
    }], fnDone);
  }

  static getAngolNyelv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'kategoria/parameter/angolnyelv',
      args: { requestType: 'kategoria-parameter-angolnyelv' },
    }], fnDone);
  }

  // KATEGORIA END

  // HELYSZIN START

  static initHelyszinek(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helszinUrl + 'hirlevel/initfilter',
      args: { requestType: 'hirlevel-initfilter' }
    }], fnDone);
  }

  // HELSZIN END

  // HIRLEVEL START

  static initFilters(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevel/initfilter',
      args: { requestType: 'hirlevel-initfilter' }
    }], fnDone);
  }

  static initVariables(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevel/init',
      args: { requestType: 'hirlevel-init' }
    }], fnDone);
  }

  static listHirlevelek(eloszuresObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'hirlevel/list',
      args: { requestType: 'hirlevel-list' },
      data: eloszuresObj
    }], fnDone);
  }

  static viewHirlevel(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevel/view',
      args: { requestType: 'hirlevel-view' },
      params: { id: id }
    }], fnDone);
  }

  static getHirlevel(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevel',
      args: { requestType: 'hirlevel-get' },
      params: { id: id }
    }], fnDone);
  }

  static addHirlevel(submitObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'hirlevel',
      args: { requestType: 'hirlevel-post' },
      data: submitObj
    }], fnDone);
  }

  static editHirlevel(submitObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'hirlevel',
      args: { requestType: 'hirlevel-post' },
      data: submitObj
    }], fnDone);
  }

  static deleteHirlevel(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.hirlevelUrl + 'hirlevel',
      args: { requestType: 'hirlevel-delete' },
      params: { id: id }
    }], fnDone);
  }

  static getCimzettekInitFilter(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevelcimzett/initfilter',
      args: { requestType: 'hirlevelcimzett-init' },
      params: { id: id }
    }], fnDone);
  }

  static getCimzettek(szurObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'hirlevelcimzett/list',
      args: { requestType: 'hirlevelcimzett-list' },
      data: szurObj
    }], fnDone);
  }



  // HIRLEVEL END
  
  // HIRLEVELKULDES START

  static getHirlevelCimzett(id, fnDone) {
  Lib.MicroServices.requestService([{
    method: 'GET',
    url: Service.hirlevelUrl + 'hirlevelcimzett/list',
    args: { requestType: 'hirlevel-get' },
    params: { id: id }
  }], fnDone);
  }

  static getHirlevelCimzettInit(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevelcimzett/init',
      args: { requestType: 'hirlevel-init' },
      params: { id: id }
    }], fnDone);
  }

  static getHirlevelCimzettCount(hirlevelId, ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'hirlevelcimzett/count',
      args: { requestType: 'hirlevel-put' },
      params: { id: hirlevelId },
      data: ids
    }], fnDone);
  }

  static saveHirlevelCimzett(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'hirlevelcimzett',
      args: { requestType: 'hirlevel-post' },
      data: data
    }], fnDone);
  }

  static saveAndSendHirlevelCimzett(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'hirlevelcimzett/send',
      args: { requestType: 'hirlevel-send' },
      data: data
    }], fnDone);
  }

  // HIRLEVELKULDES END

  // TESZT KULDES START

  static tesztKuldes(hirlevelId, email, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'hirlevel/test',
      args: { requestType: 'hirlevel-test' },
      params: {
        id: hirlevelId,
        ema: email
      }
    }], fnDone);
  }

  // TESZT KULDES END

  // LEIRATKOZAS START

  static listLeiratkozasok(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'leiratkozasok/list',
      args: { requestType: 'leiratkozasok-list' }
    }], fnDone);
  }

  static addLeiratkozas(leiratkozasObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.hirlevelUrl + 'leiratkozasok',
      args: { requestType: 'leiratkozasok-post' },
      data: leiratkozasObj
    }], fnDone);
  }

  static getLeiratkozas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.hirlevelUrl + 'leiratkozasok',
      args: { requestType: 'leiratkozasok-get' },
      params: { id: id }
    }], fnDone);
  }
  
  static editLeiratkozas(leiratkozasObj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.hirlevelUrl + 'leiratkozasok',
      args: { requestType: 'leiratkozasok-put' },
      data: leiratkozasObj
    }], fnDone);
  }

  static deleteLeiratkozas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.hirlevelUrl + 'leiratkozasok',
      args: { requestType: 'leiratkozasok-delete' },
      params: { id: id }
    }], fnDone);
  }

  // LEIRATKOZAS END

  // IMAGE START

  static listEditorImages(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.hirlevelUrl + "editor/list",
          args: { requestType: "editor-list-get" }
        }
      ],
      fnDone
    );
  }
  static uploadEditorImage(file, id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "POST",
          url: Service.hirlevelUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
          data: file
        }
      ],
      fnDone
    );
  }

  static deleteEditorImages(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.hirlevelUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  static deleteEditorImage(id, imageName, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.hirlevelUrl + `editor/image/${imageName}`,
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  // IMAGE END
}
